<template>
  <section class="afrm">
    <header v-if="antragfragen && tarif" class="afrm__head">
      <div class="afrm__eyebrow">
        <span class="afrm__dot"></span>
        ANTRAGSFRAGEN
      </div>
      <h2 class="afrm__title">
        {{ tarif.un_name }}
        <span class="afrm__title-sub">{{ tarif.tarif_title }}</span>
      </h2>
      <p class="afrm__sub">
        Bitte beantworten Sie die folgenden Fragen wahrheitsgemäß. Pflichtfelder
        sind mit einem Hinweis markiert.
      </p>
    </header>

    <v-alert
      v-if="!antragfragen && tarif"
      color="success"
      variant="tonal"
      density="comfortable"
      class="afrm__no-q"
    >
      <strong>Keine Gesundheitsfragen.</strong>
      Die <b>{{ tarif.un_name }} {{ tarif.tarif_title }}</b> verfügt über eine
      angenehme Ausnahme &mdash; Sie können direkt mit Schritt 2 fortfahren.
    </v-alert>

    <v-form ref="antragform" class="afrm__form">
      <div
        v-for="(frage, index) in antragfragen"
        :key="frage.antrag_id"
        :index="index"
      >
        <article
          v-if="frage.antrag_art == 1"
          class="qcard"
          :class="{ 'qcard--err': frage.showFrageError }"
        >
          <div class="qcard__body">
            <div class="qcard__text">
              <span v-html="frage.antrag_text"></span>
              <a
                v-if="frage.showFrageInfoExist != ''"
                class="qcard__info-link"
                @click="frage.show_antrag_info = !frage.show_antrag_info"
              >
                Erklärung anzeigen
              </a>
              <span v-if="frage.disabled" class="qcard__hint">
                <v-icon icon="mdi-lock-outline" size="13" class="mr-1" />
                Diese Antwort basiert auf Ihrer letzten Berechnung
              </span>
            </div>

            <div class="qcard__answer">
              <v-btn-toggle
                v-model="frage.antrag_input_default"
                :disabled="!!frage.disabled"
                mandatory
                divided
                rounded="0"
                color="primary"
                class="qtoggle"
                @update:modelValue="
                  resetUnterfrage(
                    frage.antrag_vue_index_unterfrage,
                    frage.antrag_input_default,
                    frage.antrag_oberfrage
                  );
                  validateFrage(frage);
                "
              >
                <v-btn value="ja">Ja</v-btn>
                <v-btn value="nein">Nein</v-btn>
              </v-btn-toggle>
              <div
                v-if="frage.showFrageError && frageErrorText[frage.antrag_id]"
                class="qcard__err-text"
              >
                <v-icon icon="mdi-alert-circle-outline" size="14" class="mr-1" />
                {{ frageErrorText[frage.antrag_id] }}
              </div>
            </div>
          </div>

          <v-alert
            v-if="
              frage.showFrageInfoExist &&
              (frage.show_antrag_info ||
                (frage.antrag_desc_show_wenn_ja == 1 &&
                  frage.antrag_input_default == 'ja') ||
                frage.antrag_desc_show_wenn_ja == 2)
            "
            color="primary"
            variant="tonal"
            density="comfortable"
            class="qcard__desc"
          >
            {{ frage.antrag_desc }}
          </v-alert>
        </article>

        <article
          v-if="
            frage.antrag_art == 3 &&
            frage.antrag_oberfrage > 0 &&
            frage.antrag_vue_index_oberfrage < 99 &&
            antragfragen[frage.antrag_vue_index_oberfrage]
              .antrag_input_default == 'ja'
          "
          class="qcard qcard--sub"
          :class="{ 'qcard--err': frage.showFrageError }"
        >
          <div class="qcard__body qcard__body--col">
            <div class="qcard__text">
              <span v-html="frage.antrag_text"></span>
              <a
                v-if="frage.showFrageInfoExist"
                class="qcard__info-link"
                @click="frage.show_antrag_info = !frage.show_antrag_info"
              >
                Erklärung anzeigen
              </a>
            </div>
            <v-textarea
              :error-messages="errorMessageTextDefault"
              v-model="frage.antrag_input_default"
              variant="outlined"
              density="comfortable"
              rows="2"
              hide-details="auto"
              v-on:change="
                resetOberfrageText(
                  frage.antrag_vue_index_oberfrage,
                  frage.antrag_input_default
                )
              "
              :rules="[
                checkUnterFrageTextFeld(
                  frage,
                  antragfragen[frage.antrag_vue_index_oberfrage]
                    .antrag_input_default
                ),
              ]"
              label="Ihre Antwort"
              type="text"
            />
          </div>

          <v-alert
            v-if="
              frage.showFrageInfoExist &&
              (frage.show_antrag_info ||
                (frage.antrag_desc_show_wenn_ja == 1 &&
                  frage.antrag_input_default == 'ja') ||
                frage.antrag_desc_show_wenn_ja == 2)
            "
            color="primary"
            variant="tonal"
            density="comfortable"
            class="qcard__desc"
          >
            {{ frage.antrag_desc }}
          </v-alert>
        </article>

        <article
          v-if="frage.antrag_art == 2 && frage.antrag_oberfrage == 0"
          class="qcard"
          :class="{ 'qcard--err': frage.showFrageError }"
        >
          <div class="qcard__body">
            <div class="qcard__text">
              <span v-html="frage.antrag_text"></span>
              <a
                v-if="frage.showFrageInfoExist"
                class="qcard__info-link"
                @click="frage.show_antrag_info = !frage.show_antrag_info"
              >
                Erklärung anzeigen
              </a>
              <span v-if="frage.disabled" class="qcard__hint">
                <v-icon icon="mdi-lock-outline" size="13" class="mr-1" />
                Diese Antwort basiert auf Ihrer letzten Berechnung
              </span>
            </div>
            <div class="qcard__answer qcard__answer--num">
              <v-text-field
                :disabled="!!frage.disabled"
                v-model="frage.antrag_input_default"
                type="number"
                variant="outlined"
                density="comfortable"
                hide-details="auto"
                :rules="[checkFrageZahlFeld(frage)]"
              />
            </div>
          </div>

          <v-alert
            v-if="
              frage.showFrageInfoExist &&
              (frage.show_antrag_info ||
                (frage.antrag_desc_show_wenn_ja == 1 &&
                  frage.antrag_input_default == 'ja') ||
                frage.antrag_desc_show_wenn_ja == 2)
            "
            color="primary"
            variant="tonal"
            density="comfortable"
            class="qcard__desc"
          >
            {{ frage.antrag_desc }}
          </v-alert>
        </article>

        <article
          v-if="
            frage.antrag_art == 2 &&
            frage.antrag_oberfrage > 0 &&
            frage.antrag_vue_index_oberfrage < 99 &&
            antragfragen[frage.antrag_vue_index_oberfrage]
              .antrag_input_default == 'ja'
          "
          class="qcard qcard--sub"
          :class="{ 'qcard--err': frage.showFrageError }"
        >
          <div class="qcard__body">
            <div class="qcard__text">
              <span v-html="frage.antrag_text"></span>
              <span v-if="frage.disabled" class="qcard__hint">
                <v-icon icon="mdi-lock-outline" size="13" class="mr-1" />
                Diese Antwort basiert auf Ihrer letzten Berechnung
              </span>
            </div>
            <div class="qcard__answer qcard__answer--num">
              <v-text-field
                :disabled="!!frage.disabled"
                v-model="frage.antrag_input_default"
                type="number"
                label="Anzahl"
                variant="outlined"
                density="comfortable"
                hide-details="auto"
                v-on:change="
                  resetOberfrageZahl(
                    frage,
                    antragfragen[frage.antrag_vue_index_oberfrage]
                      .antrag_input_default,
                    frage.antrag_vue_index_oberfrage
                  )
                "
                :rules="[
                  checkUnterFrageZahlFeld(
                    frage,
                    antragfragen[frage.antrag_vue_index_oberfrage]
                      .antrag_input_default,
                    frage.antrag_vue_index_oberfrage
                  ),
                ]"
              />
            </div>
          </div>

          <v-alert
            v-if="
              frage.showFrageInfoExist &&
              (frage.show_antrag_info ||
                (frage.antrag_desc_show_wenn_ja == 1 &&
                  frage.antrag_input_default == 'ja') ||
                frage.antrag_desc_show_wenn_ja == 2)
            "
            color="primary"
            variant="tonal"
            density="comfortable"
            class="qcard__desc"
          >
            {{ frage.antrag_desc }}
          </v-alert>
        </article>

        <article
          v-if="frage.antrag_art == 3 && frage.antrag_oberfrage == 0"
          class="qcard"
          :class="{ 'qcard--err': frage.showFrageError }"
        >
          <div class="qcard__body qcard__body--col">
            <div class="qcard__text">
              <span>{{ frage.antrag_text }}</span>
              <a
                v-if="frage.showFrageInfoExist"
                class="qcard__info-link"
                @click="frage.show_antrag_info = !frage.show_antrag_info"
              >
                Erklärung anzeigen
              </a>
            </div>
            <v-textarea
              :error-messages="errorMessageTextDefault"
              v-model="frage.antrag_input_default"
              variant="outlined"
              density="comfortable"
              rows="2"
              hide-details="auto"
              :rules="[checkFrageTextFeld(frage)]"
              label="Ihre Antwort"
              type="text"
            />
          </div>

          <v-alert
            v-if="
              frage.showFrageInfoExist &&
              (frage.show_antrag_info ||
                (frage.antrag_desc_show_wenn_ja == 1 &&
                  frage.antrag_input_default == 'ja') ||
                frage.antrag_desc_show_wenn_ja == 2)
            "
            color="primary"
            variant="tonal"
            density="comfortable"
            class="qcard__desc"
          >
            {{ frage.antrag_desc }}
          </v-alert>
        </article>
      </div>
    </v-form>
  </section>
</template>

<script setup>
  import { ref, watch, defineProps, onMounted, defineEmits, reactive } from "vue";

  import BaseCalls from "@/services/BaseCalls";
  import { useLoaderStore } from "@/stores/loaderStore";
  import { useRoute } from "vue-router";
  import { useErrorStore } from "@/stores/errorStore";
  const errorStore = useErrorStore();
  const loaderStore = useLoaderStore();
  const route = useRoute();
  const emit = defineEmits([
    "updatedTarif",
    "updateAntrag",
    "updateBerechnung",
  ]);

  const props = defineProps({
    token: { type: String },
    tarif_id: { type: String },
  });

  const tarif = ref(false);
  const antragfragen = ref(false);
  const antragfragen_count = ref(0);
  const berechnung = ref(false);
  const errorMessageTextDefault = ref(false);
  const frageErrorText = reactive({});

  function setLoading(loading) {
    loaderStore.setLoader(loading);
  }

  const setShowFrageError = (antrag_id, showError) => {
    const frage = antragfragen.value.find((f) => f.antrag_id === antrag_id);
    if (frage) {
      frage.showFrageError = showError;
    }
  };

  function validateFrage(frage) {
    let result = true;
    if (frage.antrag_art == 1) {
      result = checkFrageJaNein(frage);
    } else if (frage.antrag_art == 2 && frage.antrag_oberfrage == 0) {
      result = checkFrageZahlFeld(frage);
    } else if (
      frage.antrag_art == 2 &&
      frage.antrag_oberfrage > 0 &&
      frage.antrag_vue_index_oberfrage < 99
    ) {
      result = checkUnterFrageZahlFeld(
        frage,
        antragfragen.value[frage.antrag_vue_index_oberfrage].antrag_input_default
      );
    } else if (frage.antrag_art == 3 && frage.antrag_oberfrage == 0) {
      result = checkFrageTextFeld(frage);
    } else if (
      frage.antrag_art == 3 &&
      frage.antrag_oberfrage > 0 &&
      frage.antrag_vue_index_oberfrage < 99
    ) {
      result = checkUnterFrageTextFeld(
        frage,
        antragfragen.value[frage.antrag_vue_index_oberfrage].antrag_input_default
      );
    }
    frageErrorText[frage.antrag_id] = result === true ? "" : result;
  }

  function resetOberfrageText(oberfrage_index, value) {
    if (
      (parseInt(value) === 0 ||
        value === null ||
        value === undefined ||
        value === "") &&
      oberfrage_index < 99
    ) {
      antragfragen.value[oberfrage_index].antrag_input_default = "nein";
    }
  }

  function resetUnterfrage(subQuestionIndex, value, oberfrage) {
    if (oberfrage == 0) {
      if (value === "nein" && subQuestionIndex < 99) {
        const question = antragfragen.value[subQuestionIndex];
        if (typeof question.antrag_input_default === "number") {
          question.antrag_input_default = 0;
        } else {
          setShowFrageError(
            antragfragen.value[subQuestionIndex].antrag_id,
            false
          );
          question.antrag_input_default =
            antragfragen.value[subQuestionIndex].resetInputValue;
        }
      }
    }
  }
  function resetOberfrageZahl(frage, valueOberfrage, indexOberfrage) {
    const inputNumber = parseInt(frage.antrag_input_default, 10);
    if (valueOberfrage === "ja") {
      if (inputNumber === 0) {
        antragfragen.value[indexOberfrage].antrag_input_default = "nein";
      } else if (isNaN(inputNumber)) {
        antragfragen.value[indexOberfrage].antrag_input_default = "nein";
      }
    }
  }
  function checkUnterFrageZahlFeld(frage, valueOberfrage) {
    const inputNumber = parseInt(frage.antrag_input_default, 10);
    const checkNumber = parseInt(frage.antrag_input_max, 10);
    if (valueOberfrage === "ja") {
      if (inputNumber < 0) {
        setShowFrageError(frage.antrag_id, true);
        return "Bitte beantworten Sie diese Frage mit einer Zahl > 0.";
      }
      if (inputNumber == 0) {
        setShowFrageError(frage.antrag_id, true);
        return "Bitte beantworten Sie diese Frage mit einer Zahl > 0.";
      }
      if (isNaN(inputNumber)) {
        setShowFrageError(frage.antrag_id, true);
        return "Bitte beantworten Sie diese Frage mit einer Zahl > 0.";
      }
      if (checkNumber > 0 && inputNumber > checkNumber) {
        setShowFrageError(frage.antrag_id, true);
        return `Nur bis maximal ${checkNumber} abschließbar.`;
      }
    }
    setShowFrageError(frage.antrag_id, false);
    return true;
  }

  function checkFrageZahlFeld(frage) {
    const inputNumber = parseInt(frage.antrag_input_default, 10);
    const checkNumber = parseInt(frage.antrag_input_max, 10);
    if (checkNumber > 0 && inputNumber > checkNumber) {
      setShowFrageError(frage.antrag_id, true);
      return `Nur bis maximal ${checkNumber} abschließbar.`;
    }
    setShowFrageError(frage.antrag_id, false);
    return true;
  }

  function checkUnterFrageTextFeld(frage, valueOberfrage) {
    if (valueOberfrage == "ja" && frage.antrag_input_default === "") {
      setShowFrageError(frage.antrag_id, true);
      return "Bitte beantworten Sie diese Frage.";
    }
    setShowFrageError(frage.antrag_id, false);
    return true;
  }
  function checkFrageTextFeld(frage) {
    if (
      frage.antrag_text_must == 1 &&
      (frage.antrag_input_default === "" ||
        frage.antrag_input_default == null)
    ) {
      setShowFrageError(frage.antrag_id, true);
      errorMessageTextDefault.value = "Bitte beantworten Sie diese Frage.";
      return "Bitte beantworten Sie diese Frage.";
    }
    errorMessageTextDefault.value = false;
    setShowFrageError(frage.antrag_id, false);
    return true;
  }
  function checkFrageJaNein(frage) {
    if (
      frage.antrag_input_default === "" ||
      frage.antrag_input_default == null
    ) {
      setShowFrageError(frage.antrag_id, true);
      return "Bitte beantworten Sie diese Frage.";
    }
    if (
      frage.antrag_input_default === "ja" &&
      frage.antrag_input_ja === "nein"
    ) {
      setShowFrageError(frage.antrag_id, true);
      return "Tarif nur abschließbar, wenn Sie diese Frage mit 'Nein' beantworten können.";
    }
    if (
      frage.antrag_input_default === "nein" &&
      frage.antrag_input_ja === "ja"
    ) {
      setShowFrageError(frage.antrag_id, true);
      return "Tarif nur abschließbar, wenn Sie diese Frage mit 'Ja' beantworten können.";
    }
    setShowFrageError(frage.antrag_id, false);
    return true;
  }

  async function getVergleich() {
    setLoading(true);
    let berSelect = {};
    berSelect.action = "getTarifAntragBerechnung";
    berSelect.ber_identity_token = props.token;
    berSelect.tarif_id = props.tarif_id;
    berSelect.showPreisJahrePlus = 1;
    try {
      const resp = await BaseCalls.postTarif(berSelect);
      if (resp.data && resp.data.berechnung) {
        tarif.value = resp.data.tarif;
        berechnung.value = resp.data.berechnung;
        antragfragen_count.value = resp.data.antragfragen_count;
        antragfragen.value = resp.data.antragfragen;
        emit("updatedTarif", resp.data.tarif);
        emit("updateBerechnung", resp.data.berechnung);
        if (Array.isArray(antragfragen.value)) {
          antragfragen.value.forEach((f) => validateFrage(f));
        }
        setLoading(false);
      } else {
        setLoading(false);
        errorStore.setError(true, "Dieser Tarif ist nicht beantragbar.");
      }
    } catch (err) {
      console.log("error berechnung");
    }
  }

  watch(antragfragen, (newValue) => {
    emit("updateAntrag", newValue);
  });
  watch(
    () => route.params,
    () => {
      getVergleich();
    },
    { deep: true }
  );
  onMounted(() => {
    getVergleich();
  });
</script>

<style scoped>
  .afrm {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .afrm__head {
    background: #ffffff;
    border: 1px solid #d8dde5;
    border-left: 3px solid #0f4c81;
    border-radius: 3px;
    padding: 10px 14px;
  }
  .afrm__eyebrow {
    display: inline-flex;
    align-items: center;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.2px;
    color: #5b6473;
    text-transform: uppercase;
    margin-bottom: 4px;
  }
  .afrm__dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #0f4c81;
    margin-right: 8px;
  }
  .afrm__title {
    font-size: 18px;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
    line-height: 1.2;
    letter-spacing: -0.2px;
  }
  .afrm__title-sub {
    font-weight: 500;
    color: #4b5563;
    margin-left: 4px;
  }
  .afrm__sub {
    font-size: 13px;
    color: #4b5563;
    margin: 4px 0 0;
  }

  .afrm__no-q {
    border-radius: 3px !important;
  }

  .afrm__form {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .qcard {
    background: #ffffff;
    border: 1px solid #d8dde5;
    border-radius: 3px;
    padding: 10px 14px;
    transition: border-color 0.15s ease, background-color 0.15s ease;
  }
  .qcard--sub {
    background: #f7f9fc;
    border-color: #e5e9f0;
    margin-left: 16px;
    border-left: 3px solid #c7d8eb;
  }
  .qcard--err {
    border-color: #f5c4ba;
    background: #fff5f0;
  }

  .qcard__body {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 10px 16px;
    align-items: start;
  }
  .qcard__body--col {
    grid-template-columns: 1fr;
  }
  .qcard__text {
    font-size: 14px;
    color: #1f2937;
    line-height: 1.45;
  }
  .qcard__text :deep(strong),
  .qcard__text :deep(b) {
    color: #0f172a;
  }

  .qcard__info-link {
    display: inline-block;
    margin-left: 4px;
    font-size: 12.5px;
    color: #0f4c81;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
  }
  .qcard__info-link:hover {
    text-decoration: underline;
  }

  .qcard__hint {
    display: inline-flex;
    align-items: center;
    margin-top: 4px;
    font-size: 12px;
    color: #6b7280;
  }

  .qcard__answer {
    align-self: center;
    min-width: 200px;
  }
  .qcard__answer--num {
    min-width: 140px;
    max-width: 180px;
  }

  .qtoggle :deep(.v-btn) {
    border-radius: 0 !important;
    text-transform: none;
    font-weight: 600;
    letter-spacing: 0;
    min-width: 88px;
  }

  .qcard__err-text {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 6px;
    font-size: 12px;
    color: #b91c1c;
    line-height: 1.35;
  }

  .qcard__desc {
    margin-top: 8px;
    border-radius: 3px !important;
    font-size: 13px;
  }

  .qcard :deep(.v-field) {
    border-radius: 3px;
  }

  @media (max-width: 720px) {
    .qcard__body {
      grid-template-columns: 1fr;
    }
    .qcard__answer,
    .qcard__answer--num {
      min-width: 0;
      max-width: none;
    }
    .qtoggle :deep(.v-btn-toggle) {
      width: 100%;
    }
    .qtoggle :deep(.v-btn) {
      flex: 1 1 0;
      min-width: 0 !important;
    }
    .qcard--sub {
      margin-left: 0;
    }
  }
</style>
